module.exports = __webpack_public_path__ + "static/share-image-97b45c87446b4b5310aa6efd4358fb25.png";